import { DEFAULT_SPACE_NAME } from "views/constants";
import { ScanInput } from "types/generated";

import { ScanDetails } from "./hooks/useScan/gql";
import { NewScanScheduleFormFields } from "./types";

export const getDefaultFormValues = (scan?: ScanDetails): NewScanScheduleFormFields => {
  if (!scan) {
    return {
      name: "",
      space: DEFAULT_SPACE_NAME,
      labels: [],
      description: "",
      providerVersion: "",
      integrationId: "",
      regions: [],
      workerPoolId: "",
      resourceTypes: [],
    };
  }

  return {
    name: scan.name,
    space: scan.space.id,
    labels: scan.labels.map((value) => ({ value })),
    description: scan.description,
    providerVersion: scan.providerConfigs[0]?.version ?? "",
    integrationId: scan.providerConfigs[0]?.integration ?? "",
    regions: scan.providerConfigs.map(({ config }) => config.region),
    workerPoolId: scan.workerPool,
    resourceTypes: scan.scope.map(({ type }) => type),
  };
};

export const mapFormValuesToScanInput = (formValues: NewScanScheduleFormFields): ScanInput => ({
  name: formValues.name,
  description: formValues.description,
  labels: formValues.labels.map(({ value }) => value),
  space: formValues.space,
  // One ScanProviderConfigInput entry per selected AWS region, all pinned to the same version
  // and integration — the backend rejects a provider configured with more than one version
  // across its entries.
  providerConfigs: formValues.regions.map((region) => ({
    version: formValues.providerVersion,
    integration: formValues.integrationId,
    aws: { region },
    throttleInterval: null,
  })),
  workerPool: formValues.workerPoolId,
  // Filters stay empty until the ResourceFilters step is built.
  scope: formValues.resourceTypes.map((type) => ({ type, filters: [] })),
  runnerImage: null,
});
